import { render } from "./AddCampaign.vue?vue&type=template&id=4cdd9985"
import script from "./AddCampaign.vue?vue&type=script&lang=js"
export * from "./AddCampaign.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Cesar\\Documents\\Proyectos\\POSVitialife\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__